// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { CartItem } from '@coveo/headless-react/ssr-commerce'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { CartItemWithMetadata } from '@coveo/headless/commerce'
import { CoveoCommerceState } from "@NA/Store/Data/CoveoCommerceState";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import {
    getSelectedCategoryPath,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export function hasEngine(coveoCommerce: CoveoCommerceState) {
    return IS_SERVER_SIDE
        ? coveoCommerce.engineDefinition !== null
        : coveoCommerce.engineDefinition !== null && coveoCommerce.isEngineLoadedOnClient;
}

export function isCoveoLoading(coveoCommerce: CoveoCommerceState) {
    return (
        !hasEngine(coveoCommerce) ||
        coveoCommerce.isEngineLoading ||
        !coveoCommerce.staticState ||
        coveoCommerce.isStaticStateLoading
    );
}

export function getPath(state: CustomApplicationState) {
    const location = getLocation(state);
    const selectedCategoryPath = getSelectedCategoryPath(state);
    const pathnameLowerCase = location.pathname.toLowerCase();
    return (
        selectedCategoryPath ||
        (pathnameLowerCase.startsWith("/content/") || pathnameLowerCase.startsWith("/.spire/") ? "" : location.pathname)
    );
}

export function getSearchPath(state: CustomApplicationState) {
    return getSettingsCollection(state).searchSettings.searchPath;
}

export function getSearchParams(state: CustomApplicationState) {
    const location = getLocation(state);
    return location.search;
}

export function getSearchQuery(state: CustomApplicationState) {
    const location = getLocation(state);
    const params = new URLSearchParams(location.search);
    return params.get("q");
}

export function isSearch(state: CustomApplicationState) {
    const path = getPath(state);
    const searchPath = getSearchPath(state);
    return !!path.toLowerCase().startsWith(`/${searchPath.toLowerCase()}`);
}

export function isPlp(state: CustomApplicationState) {
    const page = getCurrentPage(state).type;
    return page === "ProductListPage";
}

// Cart Local Storage
const cartItemsKey = 'coveo-cartItems'

export const saveCartItemsToStorage = (cartItems: CartItem[] | null): void => {
    if (!cartItems || typeof window === 'undefined') { return }
    try {
        window.localStorage.setItem(
            cartItemsKey,
            JSON.stringify(cartItems)
        )
    } catch (err) {
        console.error('Failed to save cart items to local storage', err)
    }
}

export const loadCartItemsFromStorage = (): CartItemWithMetadata[] | null => {
    if (typeof window === 'undefined') { return null }
    try {
        const cartItems = window.localStorage.getItem(cartItemsKey)
        return cartItems ? JSON.parse(cartItems) as CartItemWithMetadata[] : null
    } catch (err) {
        console.error('Failed to load cart items from local storage', err)
        return null
    }
}